
    export interface IOverpaymentConfirmationModalScope extends ng.IScope {
        overpaymentConfirmationModalCtrl: OverpaymentConfirmationModalCtrl;
    }

    export class OverpaymentConfirmationModalCtrl {
        public currentBalance: string;
        public amountToCollect: string;

        public static $inject = ['$scope', '$modalInstance', 'passedInCurrentBalance', 'passedInAmountToCollect'];

        constructor($scope: IOverpaymentConfirmationModalScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public passedInCurrentBalance: string,
            public passedInAmountToCollect: string) {
            $scope.overpaymentConfirmationModalCtrl = this;
            this.currentBalance = passedInCurrentBalance;
            this.amountToCollect = passedInAmountToCollect;
        }

        public submit = () => {
            this.$modalInstance.close(true);
        }

        public close = () => {
            this.$modalInstance.close(false);
        
    }
}